import { render, staticRenderFns } from "./AppTag.vue?vue&type=template&id=1385aaab"
import script from "./AppTag.vue?vue&type=script&lang=js"
export * from "./AppTag.vue?vue&type=script&lang=js"
import style0 from "./AppTag.vue?vue&type=style&index=0&id=1385aaab&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports